module.exports = __webpack_public_path__ + "static/media/messageWallOff_w_v2_withTele.6dbab4af.png";